import { render, staticRenderFns } from "./ClassIImedical.vue?vue&type=template&id=26a410ac&scoped=true&"
import script from "./ClassIImedical.vue?vue&type=script&lang=js&"
export * from "./ClassIImedical.vue?vue&type=script&lang=js&"
import style0 from "./ClassIImedical.vue?vue&type=style&index=0&id=26a410ac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a410ac",
  null
  
)

export default component.exports